(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(36104);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_404; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./api/shop.ts + 1 modules
var shop = __webpack_require__(65564);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 31 modules
var MainLayout = __webpack_require__(76529);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./images/404.png
/* harmony default export */ var _404 = ({"src":"/_next/static/media/404.5e55faf0.png","height":449,"width":748,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAQAAADSmGXeAAAAYElEQVR42gFVAKr/AAAA/wD8cvb69vr8cOsAqwcAAA6mlvb/6P/r//f/01YAWgAAWrTE7v/c+uH67P+srgBiAAA2k4ft/+//7v/t/55WAGYAAADRAPxy9Pr0+v5wpQAAAF+XMYJe78ylAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./pages/404.tsx














var NotFound = function() {
    var ref = (0,react.useState)(null), content404 = ref[0], setContent404 = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var channelInfo, selectedLocale, translationsData, socialsFooter, ref, menus, footerMenus, coreConfigs, requestInfo, categories, pageProps;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            shop["default"].getChannelInfo404({
                                locale: router.locale
                            })
                        ];
                    case 1:
                        channelInfo = _state.sent();
                        selectedLocale = channelInfo.selectedLocale;
                        return [
                            4,
                            shop["default"].postTranslationsNew404({
                                locale: selectedLocale
                            })
                        ];
                    case 2:
                        translationsData = _state.sent();
                        return [
                            4,
                            shop["default"].getSocialsFooter404()
                        ];
                    case 3:
                        socialsFooter = _state.sent();
                        return [
                            4,
                            shop["default"].getHeaderFooterMenus404({
                                locale: selectedLocale
                            })
                        ];
                    case 4:
                        ref = _state.sent(), menus = ref.setMenuList, footerMenus = ref.setFooterMenuList;
                        return [
                            4,
                            shop["default"].getCoreConfigs404({
                                selectedLocale: selectedLocale,
                                footerTrackItl: translationsData
                            })
                        ];
                    case 5:
                        coreConfigs = _state.sent();
                        return [
                            4,
                            shop["default"].getRequestInfo404()
                        ];
                    case 6:
                        requestInfo = _state.sent();
                        return [
                            4,
                            shop["default"].getCategories404({
                                locale: selectedLocale,
                                ONLY_FOR_TWO_KINGS: requestInfo.ONLY_FOR_TWO_KINGS
                            })
                        ];
                    case 7:
                        categories = _state.sent();
                        pageProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, coreConfigs, requestInfo, channelInfo), {
                            translationsData: translationsData,
                            socialsFooter: socialsFooter,
                            menus: menus,
                            footerMenus: footerMenus,
                            categories: categories
                        });
                        if (pageProps) {
                            setContent404(/*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "not-found__con",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "not-found__con__image",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: (0,helper/* domainUrl */.HJ)("".concat(requestInfo.dbName).concat(_404.src)),
                                                    alt: "Error page image",
                                                    placeholder: "blur",
                                                    layout: "fill",
                                                    blurDataURL: "/zega/blur1.webp",
                                                    objectFit: "contain"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "not-found__con__text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-con",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "not-found__con__text_p",
                                                            children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.PageNotAvailable
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "not-found__con__small_p",
                                                            children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.SearchOrBack
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/",
                                                            className: "not-found__con__text_a",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.GoToHome
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })));
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router.locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "404 Page Not Found"
                })
            }),
            content404
        ]
    });
};
/* harmony default export */ var pages_404 = (NotFound);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,3071,3997,6529,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);